export const ADD_EDUCATION_INFO = "ADD_EDUCATION_INFO";
export const ADD_ALL_EDUCATION_INFO = "ADD_ALL_EDUCATION_INFO";
export const ADD_COUNT = "ADD_COUNT";
export const ADD_TOTAL = "ADD_TOTAL";
export const ADD_EDU_DATA = "ADD_EDU_DATA";

export const RESET_EDU = "RESET_EDU";



export const addEduInfo = (data) => {
  return {
    type: ADD_EDUCATION_INFO,
    data,
  };
};

export const resetEdu = (data) => {
  return {
    type: RESET_EDU,
    data,
  };
};

export const addEduCount = (data) => {
  return {
    type: ADD_COUNT,
    data,
  };
};

export const addEduTotal = (data) => {
  return {
    type: ADD_TOTAL,
    data,
  };
};

export const addAllEduInfo = (data) => {
  return {
    type: ADD_ALL_EDUCATION_INFO,
    data,
  };
};
export const addEduData = (data) => {
  return {
    type: ADD_EDU_DATA,
    data,
  };
};
